import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  fetchAllDropdownData,
  fetchClientData,
} from "../../Redux/Actions/dataActions"; // Adjust the path as needed
import {
  Container,
  TextField,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
  Button,
  Typography,
  Grid,
  Autocomplete,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ListItemText,
  Chip,
  IconButton,
  Paper,
} from "@mui/material";
import MultiSelectPopup from "../Multiselectpopup";
import { RadioSelectPopup, MultiRadioSelectPopup } from "../RadioSelectPopup";
import {
  fetchSupervisionSessionGoals,
  fetchFeedbacks,
  fetchSupervisionNextSessionPlans,
} from "../../Keywords/sessionnote_97155";
import CancelIcon from "@mui/icons-material/Cancel";
import axios from "axios";
import { useSnackbar } from "../../Providers/SnackbarProvider";
import SessionNoteResponse from "../SessionNote/SessionNoteResponse";
import { useState } from "react";
import {
  LoadingIndicator,
  GenerateLoadingIndicator,
} from "../../Components/Loader";
import { BASE_API_URL } from "../../constants";
import axiosInstance from "../../api/axiosInstance";
import { margin } from "@mui/system";
import { handleSubmit } from "../SessionNote/GenerateSessionNote";
import { xorDecrypt } from "../../encrypt";
import CircularProgress from "@mui/material/CircularProgress";
import { useNotification } from "../../Components/CreditNotification";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 240,
    },
  },
};

const SessionNotesForm = ({ onFormChange }) => {
  const { showNotification } = useNotification();
  const dispatch = useDispatch();
  const sharedLink = BASE_API_URL;
  const { openSnackbar } = useSnackbar();
  const [responseDialogOpen, setResponseDialogOpen] = useState(false);
  const [responseData, setResponseData] = useState("");
  const [loading, setLoading] = useState(false);
  const enrollmentId = xorDecrypt(localStorage.getItem("latestEnrollmentId"));
  const subscriberId = xorDecrypt(localStorage.getItem("subscriberId"));
  const [clientDOB, setClientDOB] = useState("");
  const [multiselectData, setMultiselectData] = useState({});

  const [popupOpen, setPopupOpen] = useState({
    sessionGoalAddressed: false,
    feedbackProvided: false,
    nextSessionPlans: false,
    placeOfServiceCode: false,
  });

  const [values, setValues] = useState({
    // Client Information
    clientId: null,
    clientName: "",
    template: "TEMPLATE_97155",
    enrollmentId: enrollmentId,
    subscriberId: subscriberId,

    // Service Location Information
    placeOfServiceCode: "",
    otherPlaceOfService: "",

    // Procedure Information
    procedureCode: "97155",

    // Session Participants Information
    sessionParticipants: [],
    otherSessionParticipants: "",

    // Parent/Guardian Information
    parentOrGurdianName: "",

    // Additional Information
    otherInformation: [],

    // Behavior Tech Information
    behaviorTechName: "",

    feedbackRBT: "",

    sessionGoalAddressed: [],
    otherSessionGoalAddressed: "",

    feedbackProvided: [],
    otherFeedbackProvided: "",

    nextSessionPlan: [],
    otherNextSessionPlan: "",
  });

  const fullState = useSelector((state) => state, shallowEqual);
  const dropdownData = fullState.data.dropdownData.data;
  const clients = useSelector((state) => state.data.clientData.data) || [];
  const handlePopupOpen = (field) => {
    setPopupOpen((prevState) => ({ ...prevState, [field]: true }));
  };
  const [otherValues, setOtherValues] = useState({
    sessionGoalAddressed: "",
    feedbackProvided: "",
    nextSessionPlan: "",
  });
  const handlePopupClose = (field) => {
    setPopupOpen((prevState) => ({ ...prevState, [field]: false }));
  };

  useEffect(() => {
    dispatch(fetchAllDropdownData());
    dispatch(fetchClientData()); // Fetch clients if needed

    // Fetch new dropdown data
    const fetchMultiselectData = async () => {
      try {
        const [
          supervisionSessionGoals,
          feedbacks,
          supervisionNextSessionPlan,
        ] = await Promise.all([
          fetchSupervisionSessionGoals(),
          fetchFeedbacks(),
          fetchSupervisionNextSessionPlans(),
        ]);

        // Update state with fetched data
        setMultiselectData({
          supervisionSessionGoals,
          feedbacks,
          supervisionNextSessionPlan,
        });
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };
    // console.log("fetched data" + fetchMultiselectData);

    fetchMultiselectData();
  }, [dispatch]);

  useEffect(() => {
    const keysToIgnore = [
      "clientId",
      "template",
      "enrollmentId",
      "subscriberId",
      "procedureCode",
      // Add any other keys that should be ignored
    ];

    const isFormFilled = Object.entries(values).some(
      ([key, value]) =>
        !keysToIgnore.includes(key) &&
        value !== null &&
        value !== "" &&
        value.length !== 0
    );

    onFormChange(isFormFilled);
  }, [values, onFormChange]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleCustomChange = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleClientIdChange = (event, newValue) => {
    setValues((prevValues) => ({
      ...prevValues,
      clientId: newValue ? newValue.id : null,
      clientName: newValue ? newValue.clientName : "",
    }));
    if (newValue) {
      const formattedDOB = new Date(newValue.dateOfBirth)
        .toISOString()
        .split("T")[0];
      setClientDOB(formattedDOB); // Assuming the client object has a dateOfBirth field
    } else {
      setClientDOB("");
    }
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: checked,
    }));
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleDeleteChip = (name, chipToDelete) => () => {
    setValues((prevValues) => ({
      ...prevValues,
      [name]: prevValues[name].filter((chip) => chip !== chipToDelete),
    }));
  };
  if (loading) return <GenerateLoadingIndicator />;

  const updateValues = (field, selectedKeys, fullData) => {
    const selectedKeyValuePairs = selectedKeys.map((key) => {
      const item = fullData.find((dataItem) => dataItem.key === key);
      if (!item) {
        console.warn(
          `Key "${key}" does not exist in the provided data object.`
        );
        return { key, value: null }; // Handle missing key gracefully
      }
      return { id: item.id, key: item.key }; // Include predefined data for other options
    });

    setValues((prevValues) => ({
      ...prevValues,
      [field]: selectedKeyValuePairs,
    }));
  };

  const handleOtherChange = (field, value) => {
    setOtherValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const overlayStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: " none",
    backdropFilter: "blur(5px)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const colorfulTextStyle = {
    background: "linear-gradient(45deg, #ffa500, #ffffff, #ffa500)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "bold",
    marginBottom: "30px",
    marginTop: "20px",
  };

  const validateForm = () => {
    const requiredFields = [
      "clientId",
      "sessionParticipants",
      "placeOfServiceCode",
      "sessionGoalAddressed",
      "feedbackProvided",
      "nextSessionPlan",
      "parentOrGurdianName",
      "behaviorTechName",
    ];

    for (const field of requiredFields) {
      if (!values[field] || values[field].length === 0) {
        return false;
      }
    }
    return true;
  };

  const handleSubmitForm = (event) => {
    event.preventDefault();

    if (!validateForm()) {
      openSnackbar("Please fill in all required fields.", "error");
      return;
    }

    handleSubmit(
      event,
      finalValues,
      openSnackbar,
      setResponseData,
      setResponseDialogOpen,
      setLoading
    );
    showNotification("-1 Credit");
  };

  const finalValues = {
    clientId: values.clientId,
    clientName: values.clientName,
    clientDateOfBirth: clientDOB,
    enrollmentId: values.enrollmentId,
    subscriberId: values.subscriberId,
    template: values.template,

    placeOfServiceCode: values.placeOfServiceCode,
    otherPlaceOfService: values.otherPlaceOfService,

    procedureCode: values.procedureCode,

    sessionParticipants: values.sessionParticipants,
    otherSessionParticipants: values.otherSessionParticipants,

    otherInformation: values.otherInformation,

    parentOrGurdianName: values.parentOrGurdianName,

    sessionGoalAddressIds: values.sessionGoalAddressed
      .filter((item) => item && item.id !== null && item.id !== undefined)
      .map((item) => item.id),
    otherSessionGoalAddressed: values.otherSessionGoalAddressed,

    behaviorTechName: values.behaviorTechName,

    feedbackProvidedIds: values.feedbackProvided
      .filter((item) => item && item.id !== null && item.id !== undefined)
      .map((item) => item.id),
    otherFeedbackProvided: values.otherFeedbackProvided,

    nextSessionPlanIds: values.nextSessionPlan
      .filter((item) => item && item.id !== null && item.id !== undefined)
      .map((item) => item.id),
    otherNextSessionPlan: values.otherNextSessionPlan,
    // sessionObjectives: values.sessionObjectives,
  };

  return (
    <>
      {loading && (
        <Box sx={overlayStyles}>
          <GenerateLoadingIndicator />
        </Box>
      )}
      <Box padding={2} sx={{ filter: loading ? "blur(5px)" : "none" }}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            handleSubmitForm(event);
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={clients}
                name="clientId"
                getOptionLabel={(option) => option.clientName || ""}
                value={
                  clients?.find((option) => option.id === values.clientId) ||
                  null
                }
                onChange={handleClientIdChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Client Name"
                    name="clientId"
                    required
                    InputProps={{
                      ...params.InputProps,
                      sx: {
                        "& .MuiAutocomplete-input": {
                          color: "white", // Text color inside the Autocomplete input
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          color: "white", // Dropdown icon color
                        },
                        "& .MuiAutocomplete-clearIndicator": {
                          color: "white", // Clear button color
                        },
                      },
                      maxLength: 50,
                      pattern: "[A-Za-z ]*",
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "white", // Border color
                        },
                        "&:hover fieldset": {
                          borderColor: "#e9a132", // Hover state
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#e9a132", // Focused state
                        },
                      },
                      "& .MuiInputLabel-root": {
                        color: "white", // Keeps the label color consistent
                        "&.Mui-focused": {
                          color: "#e9a132", // Prevents the label color from changing on focus
                        },
                      },
                      "& .MuiFormHelperText-root": {
                        color: "white", // Helper text color
                      },
                    }}
                    // helperText="This field is required"
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Client's Date of Birth"
                value={clientDOB}
                InputProps={{
                  readOnly: true,
                  sx: {
                    color: "white", // Text color inside the input
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "white", // Border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#e9a132", // Hover state
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#e9a132", // Focused state
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "white", // Keeps the label color consistent
                    "&.Mui-focused": {
                      color: "#e9a132", // Prevents the label color from changing on focus
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "white", // Helper text color
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <TextField
                  fullWidth
                  label="Session Participants"
                  required
                  value={
                    Array.isArray(values.sessionParticipants)
                      ? values.sessionParticipants.join(", ")
                      : ""
                  }
                  onClick={() => handlePopupOpen("sessionParticipants")}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      color: "white",
                      cursor: "pointer",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "#e9a132",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#e9a132",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                      "&.Mui-focused": {
                        color: "#e9a132",
                      },
                    },
                  }}
                />
                <MultiRadioSelectPopup
                  open={popupOpen.sessionParticipants}
                  onClose={() => handlePopupClose("sessionParticipants")}
                  data={dropdownData?.participants || []} // Pass backend data directly
                  selectedValues={values.sessionParticipants}
                  setSelectedValues={(selected) => {
                    setValues((prevValues) => ({
                      ...prevValues,
                      sessionParticipants: Array.isArray(selected)
                        ? selected
                        : [selected], // Ensure it's an array
                    }));
                  }}
                  title="Session Participants"
                />
                {/* Handle "Others" dynamically */}
                {Array.isArray(values.sessionParticipants) &&
                  values.sessionParticipants.includes("Other") && (
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Specify Other Participants"
                      name="otherSessionParticipants"
                      value={values.otherSessionParticipants}
                      onChange={(e) =>
                        setValues((prevValues) => ({
                          ...prevValues,
                          otherSessionParticipants: e.target.value,
                        }))
                      }
                      inputProps={{
                        maxLength: 100,
                        pattern: "[A-Za-z,. ]*",
                        title:
                          "Only alphabets and specific special characters ( ,. ) are allowed.",
                      }}
                      sx={{
                        marginTop: 2,
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "white",
                          },
                          "&:hover fieldset": {
                            borderColor: "#e9a132",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#e9a132",
                          },
                        },
                        "& .MuiInputBase-input": {
                          color: "white",
                        },
                      }}
                    />
                  )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Place of Service"
                value={values.placeOfServiceCode || ""}
                required
                onClick={() => handlePopupOpen("placeOfServiceCode")}
                InputProps={{
                  readOnly: true,
                  sx: {
                    color: "white",
                    cursor: "pointer",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "white",
                    },
                    "&:hover fieldset": {
                      borderColor: "#e9a132",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#e9a132",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#e9a132",
                    },
                  },
                }}
              />
              <RadioSelectPopup
                open={popupOpen.placeOfServiceCode}
                onClose={() => handlePopupClose("placeOfServiceCode")}
                data={dropdownData?.placeOfServiceCode || []} // Pass placeOfServiceCode options
                selectedValue={values.placeOfServiceCode}
                setSelectedValue={(selected) => {
                  setValues((prevValues) => ({
                    ...prevValues,
                    placeOfServiceCode: selected,
                  }));
                }}
                title="Place of Service"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <TextField
                  fullWidth
                  variant="outlined"
                  required
                  label="Parent Or Caregiver Name"
                  name="parentOrGurdianName"
                  value={values.parentOrGurdianName}
                  onChange={handleChange}
                  inputProps={{
                    maxLength: 50,
                    pattern: "[A-Za-z ]*",
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(
                        /[^A-Za-z ]/g,
                        ""
                      );
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      fontSize: "1rem",
                      color: "white",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "white",
                      },
                      "& .MuiOutlinedInput-input": {
                        color: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "#e9a132",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#e9a132",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                      "&.Mui-focused": {
                        color: "#e9a132",
                      },
                    },
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <TextField
                  fullWidth
                  variant="outlined"
                  required
                  label="Behavior Technician Name"
                  name="behaviorTechName"
                  value={values.behaviorTechName}
                  onChange={handleChange}
                  inputProps={{
                    maxLength: 50,
                    pattern: "[A-Za-z ]*",
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(
                        /[^A-Za-z ]/g,
                        ""
                      );
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      fontSize: "1rem",
                      color: "white",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "white",
                      },
                      "& .MuiOutlinedInput-input": {
                        color: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "#e9a132",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#e9a132",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                      "&.Mui-focused": {
                        color: "#e9a132",
                      },
                    },
                  }}
                />
              </FormControl>
            </Grid>

            {/* add field session objective */}

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <TextField
                  fullWidth
                  label="Session Goal Addressed / Observed"
                  required
                  value={values.sessionGoalAddressed
                    .map((item) => item.key)
                    .join(", ")}
                  onClick={() => handlePopupOpen("sessionGoalAddressed")}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      color: "white",
                      cursor: "pointer",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "#e9a132",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#e9a132",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                      "&.Mui-focused": {
                        color: "#e9a132",
                      },
                    },
                  }}
                />
                <MultiSelectPopup
                  open={popupOpen.sessionGoalAddressed}
                  onClose={() => handlePopupClose("sessionGoalAddressed")}
                  data={multiselectData.supervisionSessionGoals || []}
                  selectedItems={values.sessionGoalAddressed.map(
                    (item) => item.key
                  )}
                  setSelectedItems={(selected) =>
                    updateValues(
                      "sessionGoalAddressed",
                      selected,
                      multiselectData.supervisionSessionGoals
                    )
                  }
                  title="Session Goal Addressed / Observed"
                />
                {values.sessionGoalAddressed.some(
                  (item) => item.key === "Other"
                ) && (
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Other Session Goal Addressed"
                    name="otherSessionGoalAddressed"
                    value={values.otherSessionGoalAddressed}
                    onChange={handleCustomChange}
                    required
                    inputProps={{
                      maxLength: 100,
                      pattern: "[A-Za-z,. ]*",
                      title:
                        "Only alphabets and specific special characters ( ,. ) are allowed.",
                    }}
                    InputLabelProps={{
                      style: {
                        color: "white",
                        "&.Mui-focused": {
                          color: "#e9a132",
                        },
                      },
                    }}
                    sx={{
                      marginTop: 2,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "white",
                        },
                        "&:hover fieldset": {
                          borderColor: "#e9a132",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#e9a132",
                        },
                      },
                      "& .MuiInputBase-input": {
                        color: "white",
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        color: "white",
                      },
                      "& .MuiAutocomplete-popupIndicator": {
                        color: "white",
                      },
                      ".MuiChip-label": {
                        color: "white",
                      },
                      "& .MuiChip-deleteIcon": {
                        color: "white",
                        "&:hover": {
                          color: "#ff6666",
                        },
                      },
                    }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <TextField
                  fullWidth
                  label="Feedback Provided to BT/RBT"
                  required
                  value={values.feedbackProvided
                    .map((item) => item.key)
                    .join(", ")}
                  onClick={() => handlePopupOpen("feedbackProvided")}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      color: "white",
                      cursor: "pointer",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "#e9a132",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#e9a132",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                      "&.Mui-focused": {
                        color: "#e9a132",
                      },
                    },
                  }}
                />
                <MultiSelectPopup
                  open={popupOpen.feedbackProvided}
                  onClose={() => handlePopupClose("feedbackProvided")}
                  data={multiselectData.feedbacks || []}
                  selectedItems={values.feedbackProvided.map(
                    (item) => item.key
                  )}
                  setSelectedItems={(selected) =>
                    updateValues(
                      "feedbackProvided",
                      selected,
                      multiselectData.feedbacks
                    )
                  }
                  title="Feedback Provided to BT/RBT"
                />
                {values.feedbackProvided.some(
                  (item) => item.key === "Other"
                ) && (
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Other Feedback Provided"
                    name="otherFeedbackProvided"
                    value={values.otherFeedbackProvided}
                    onChange={handleCustomChange}
                    required
                    inputProps={{
                      maxLength: 100,
                      pattern: "[A-Za-z,. ]*",
                      title:
                        "Only alphabets and specific special characters ( ,. ) are allowed.",
                    }}
                    InputLabelProps={{
                      style: {
                        color: "white",
                        "&.Mui-focused": {
                          color: "#e9a132",
                        },
                      },
                    }}
                    sx={{
                      marginTop: 2,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "white",
                        },
                        "&:hover fieldset": {
                          borderColor: "#e9a132",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#e9a132",
                        },
                      },
                      "& .MuiInputBase-input": {
                        color: "white",
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        color: "white",
                      },
                      "& .MuiAutocomplete-popupIndicator": {
                        color: "white",
                      },
                      ".MuiChip-label": {
                        color: "white",
                      },
                      "& .MuiChip-deleteIcon": {
                        color: "white",
                        "&:hover": {
                          color: "#ff6666",
                        },
                      },
                    }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <TextField
                  fullWidth
                  label="Next Session Plans"
                  required
                  value={values.nextSessionPlan
                    .map((item) => item.key)
                    .join(", ")}
                  onClick={() => handlePopupOpen("nextSessionPlan")}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      color: "white",
                      cursor: "pointer",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "#e9a132",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#e9a132",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                      "&.Mui-focused": {
                        color: "#e9a132",
                      },
                    },
                  }}
                />
                <MultiSelectPopup
                  open={popupOpen.nextSessionPlan}
                  onClose={() => handlePopupClose("nextSessionPlan")}
                  data={multiselectData.supervisionNextSessionPlan || []}
                  selectedItems={
                    values.nextSessionPlan
                      ? values.nextSessionPlan.map((item) => item.key)
                      : []
                  }
                  setSelectedItems={(selected) =>
                    updateValues(
                      "nextSessionPlan",
                      selected,
                      multiselectData.supervisionNextSessionPlan
                    )
                  }
                  title="Next Session Plans"
                />
                {values.nextSessionPlan.some(
                  (item) => item.key === "Other"
                ) && (
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Other Next Session Plans"
                    name="otherNextSessionPlan"
                    value={values.otherNextSessionPlan}
                    onChange={handleCustomChange}
                    required
                    inputProps={{
                      maxLength: 100,
                      pattern: "[A-Za-z,. ]*",
                      title:
                        "Only alphabets and specific special characters ( ,. ) are allowed.",
                    }}
                    InputLabelProps={{
                      style: {
                        color: "white",
                        "&.Mui-focused": {
                          color: "#e9a132",
                        },
                      },
                    }}
                    sx={{
                      marginTop: 2,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "white",
                        },
                        "&:hover fieldset": {
                          borderColor: "#e9a132",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#e9a132",
                        },
                      },
                      "& .MuiInputBase-input": {
                        color: "white",
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        color: "white",
                      },
                      "& .MuiAutocomplete-popupIndicator": {
                        color: "white",
                      },
                      ".MuiChip-label": {
                        color: "white",
                      },
                      "& .MuiChip-deleteIcon": {
                        color: "white",
                        "&:hover": {
                          color: "#ff6666",
                        },
                      },
                    }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                {values.otherInformation.map((info, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "6px",
                    }}
                  >
                    <TextField
                      label="Other Information"
                      name={`otherInformation[${index}]`}
                      variant="outlined"
                      value={info}
                      inputProps={{
                        maxLength: 200,
                        pattern: "[A-Za-z,. ]*",
                        title:
                          "Only alphabets and specific special characters ( ,. ) are allowed.",
                      }}
                      InputLabelProps={{
                        style: {
                          fontSize: "1rem", // Adjust font size as needed
                          color: "white", // Change label color
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "white", // Border color
                          },
                          "& .MuiOutlinedInput-input": {
                            color: "white",
                          },
                          "&:hover fieldset": {
                            borderColor: "#e9a132", // Hover state
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#e9a132", // Focused state
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "white", // Keeps the label color consistent
                          "&.Mui-focused": {
                            color: "#e9a132", // Prevents the label color from changing on focus
                          },
                        },
                      }}
                      fullWidth
                      onChange={(e) => {
                        const updatedInfo = [...values.otherInformation];
                        updatedInfo[index] = e.target.value;
                        setValues({
                          ...values,
                          otherInformation: updatedInfo,
                        });
                      }}
                    />
                    <IconButton
                      onClick={() => {
                        const updatedInfo = values.otherInformation.filter(
                          (_, i) => i !== index
                        );
                        setValues({
                          ...values,
                          otherInformation: updatedInfo,
                        });
                      }}
                    >
                      <CancelIcon sx={{ color: "red" }} />
                    </IconButton>
                  </Box>
                ))}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    sx={{
                      margin: "8px 0",
                      width: "100%", // Make the button fill the entire width
                      padding: "8px 12px", // Decrease padding for a smaller button height
                      backgroundColor: "#e9a132", // Change button background color
                      color: "white", // Change text color for better contrast
                      "&:hover": {
                        backgroundColor: "#c7912c", // Slightly darker shade on hover
                      },
                    }}
                    onClick={() =>
                      setValues({
                        ...values,
                        otherInformation: [...values.otherInformation, ""],
                      })
                    }
                  >
                    + More Information
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                      margin: "8px 0",
                      width: "100%", // Make the button fill the entire width
                      padding: "8px 12px", // Decrease padding for a smaller button height
                      backgroundColor: "#e9a132", // Change button background color
                      color: "white", // Change text color for better contrast
                      "&:hover": {
                        backgroundColor: "#c7912c", // Slightly darker shade on hover
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </FormControl>
            </Grid>

            {/* Form end */}
          </Grid>
        </form>
      </Box>

      <SessionNoteResponse
        open={responseDialogOpen}
        onClose={() => setResponseDialogOpen(false)}
        handleSubmit={handleSubmit}
        clients={clients}
        InitialValues={finalValues}
        procedureCode={values.procedureCode}
        placeOfServiceCode={values.placeOfServiceCode}
        sessionParticipants={values.participants}
        responseData={responseData}
      />
    </>
  );
};

export default SessionNotesForm;
